<div class="ab-cards">
  <div class="ab-card ab-card--white">
    New errors
    <h1 class="ab-card__data">
      {{ newGroupCount | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="newGroupCountList"
        [dur]="dur"
        [statType]="'new errors'"
      ></ab-trend>
    </h1>
  </div>
  <div class="ab-card ab-card--white">
    Occurrences accepted
    <h1 class="ab-card__data">
      {{ acceptedCount | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="acceptedCountList"
        [dur]="dur"
        [statType]="'accepted errors'"
      ></ab-trend>
    </h1>
  </div>
  <div class="ab-card ab-card--white">
    <a
      uiSref="project-deploys"
      [uiParams]="{ projectId: project.id, dur: dur, last_n: lastN }"
      >Deploys</a
    >
    <h1 class="ab-card__data">
      {{ deployCount | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="deployCountList"
        [neutralStyle]="true"
        [dur]="dur"
        [statType]="'deploys'"
      ></ab-trend>
    </h1>
  </div>
  <div class="ab-card ab-card--white" *ngIf="diffStatAggregations">
    Code
    <h1 class="ab-card__data ab-card__data--small">
      <span class="color--success">+</span
      ><span>{{ diffStatAggregations.additions | numberToHuman }}</span
      >&nbsp;<span class="color--danger">-</span
      ><span>{{ diffStatAggregations.deletions | numberToHuman }}</span>
    </h1>
  </div>
</div>
